document.addEventListener('DOMContentLoaded', () => {
  const dataLayerElements = document.querySelectorAll('[data-event]');

  dataLayerElements.forEach(el => {
    el.addEventListener('click', () => {
      const eventEvent = el.getAttribute('data-event');
      const eventName = el.getAttribute('data-name');
      const eventThema = el.getAttribute('data-thematique');
      const eventFormat = el.getAttribute('data-format');
      const eventPosition = el.getAttribute('data-position');
      const eventDate = el.getAttribute('data-date');
      const eventLevel1 = el.getAttribute('data-level-1');
      const eventLevel2 = el.getAttribute('data-level-2');
      const eventLevel3 = el.getAttribute('data-level-3');

      if (eventEvent == 'clic_etude') {
        window.dataLayer.push({
          'event': eventEvent,
          'clic_etude': {
              'etude_name': eventName,
              'etude_thematique': eventThema,
              'etude_format': eventFormat,
            }
        });
      }

      if (eventEvent == 'clic_outil') {
        window.dataLayer.push({
          'event': eventEvent,
          'clic_outil': {
            'outil_name': eventName,
            'outil_thematique': eventThema,
            'outil_format': eventFormat,
          }
        });
      }

      if (eventEvent == 'clic_article') {
        window.dataLayer.push({
          'event': eventEvent,
          'clic_article': {
            'article_name': eventName,
            'article_thematique': eventThema,
            'article_format': eventFormat,
          }
        });
      }

      if (eventEvent == 'clic_cta') {
        window.dataLayer.push({
          'event': eventEvent,
          'clic_cta': {
            'label': eventName,
            'position': eventPosition,
          }
        });
      }

      if (eventEvent == 'clic_footer') {
        window.dataLayer.push({
          'event': eventEvent,
          'clic_footer': {
            'label': eventName,
          }
        });
      }

      if (eventEvent == 'clic_webinaire_a_la_une') {
        window.dataLayer.push({
          'event': eventEvent,
          'clic_webinaire_a_la_une': {
            'type' : 'Webinaire à la une',
            'webinaire_name': eventName,
            'webinaire_date': eventDate,
          }
        });
      }

      if (eventEvent == 'clic_actu_a_la_une') {
        window.dataLayer.push({
          'event': eventEvent,
          'clic_actu_a_la_une': {
            'type' : 'Actu à la une',
            'article_name': eventName,
            'article_thematique': eventThema,
            'article_format': eventFormat,
          }
        });
      }

      if (eventEvent == 'clic_ressources') {
        window.dataLayer.push({
          'event': eventEvent,
          'clic_ressources': {
            'ressource_name': eventName,
          }
        });
      }

      if (eventEvent == 'clic_inscription_webinaire') {
        window.dataLayer.push({
          'event': eventEvent,
          'clic_inscription_webinaire': {
            'webinaire_name': eventName,
            'webinaire_date': eventDate,
          }
        });
      }

      if (eventEvent == 'clic_navbar') {
        const navData = {
          'label': eventName,
          'niveau_1': eventLevel1,
          'niveau_2': eventLevel2
        };

        if (eventLevel3) {
          navData.niveau_3 = eventLevel3;
        }

        window.dataLayer.push({
          'event': eventEvent,
          'clic_navbar': navData
        });
      }
    });
  });
})
